import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { BonusOutcomeSection } from './components/BonusOutcomeSection';
import { OfferSection } from './components/OfferSection';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}
export function App() {
  useEffect(() => {
    try {
      if (window.fbq) return;
      const pixel = ((...args: unknown[]) => {
        if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
      }) as PixelFunction;
      pixel.queue = [];
      pixel.push = pixel;
      pixel.loaded = true;
      pixel.version = '2.0';
      window.fbq = pixel;
      window._fbq = pixel;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript?.parentNode) firstScript.parentNode.insertBefore(script, firstScript);else document.head.appendChild(script);
      pixel('init', '1800959151086934');
      pixel('track', 'PageView');
    } catch {/* Pixel loading must never interrupt a preview or page render. */}
  }, []);
  return <><noscript data-id="element-0" data-mp="3dlnu6g324zya"><img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1800959151086934&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="3dmfqxu8e53q5" /></noscript><div className="min-h-screen w-full overflow-x-hidden bg-canvas" data-id="element-2" data-mp="sudkecc4nt77"><main data-id="element-3" data-mp="ssssyvl40qdk"><Hero data-id="element-4" data-mp="swqaxdvybbvv" /><PainSection data-id="element-5" data-mp="swgk5o3310p4" /><SystemSection data-id="element-6" data-mp="36hvn4muyo06" /><BonusOutcomeSection data-id="element-7" data-mp="35yomiyqxk0x" /><OfferSection data-id="element-8" data-mp="35gmx6tbedlm" /><Guarantee data-id="element-9" data-mp="34x0pdwmt31s" /><Testimonials data-id="element-10" data-mp="34ncnvv5d5yq" /><FAQ data-id="element-11" data-mp="38b4mqky1kbc" /><FinalCTA data-id="element-12" data-mp="38b2ol1dva8p" /></main><Footer data-id="element-13" data-mp="3ud1e95yxri91" /><PurchaseToast data-id="element-14" data-mp="3udazkg91d18e" /></div></>;
}